import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Bell, EnvelopeSimple } from "@phosphor-icons/react";

const PREFS = [
  ["weekly_digest", "Weekly business report", "Monday morning digest with products fixed, missing listings, health changes."],
  ["low_stock", "Low stock alerts", "When any SKU drops below your threshold."],
  ["sync_errors", "Sync errors", "When a listing fails to publish or sync."],
  ["ai_complete", "AI job complete", "When bulk AI completion or image analysis finishes."],
  ["payment_receipts", "Payment receipts", "When Razorpay activates or renews platform access."],
];

export default function Notifications() {
  const [prefs, setPrefs] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => { api.get("/notifications/preferences").then(r => setPrefs(r.data)); }, []);

  const toggle = async (k) => {
    const upd = { ...prefs, [k]: !prefs[k] };
    setPrefs(upd);
    try { await api.patch("/notifications/preferences", { [k]: upd[k] }); toast.success("Saved"); }
    catch { toast.error("Failed"); }
  };

  const testDigest = async () => {
    setSending(true);
    try {
      const r = await api.post("/notifications/send-weekly-digest");
      toast.success(`Digest sent to ${r.data.sent} · skipped ${r.data.skipped}`);
    } catch { toast.error("Send failed. Configure SMTP in backend/.env."); }
    finally { setSending(false); }
  };

  if (!prefs) return <div className="font-mono-data text-sm text-muted-foreground">Loading…</div>;

  return (
    <div className="space-y-6 min-w-0 max-w-3xl" data-testid="notifications-page">
      <div>
        <div className="eyebrow mb-1">Notifications</div>
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tighter text-navy">Preferences</h1>
        <p className="text-muted-foreground mt-2 text-sm">Choose what EcomKit should tell you about.</p>
      </div>

      <div className="card-base p-6 space-y-3">
        {PREFS.map(([k, t, d]) => (
          <label key={k} data-testid={`pref-${k}`} className="flex items-start gap-4 p-3 border border-border rounded-lg hover:border-navy/40 transition-colors cursor-pointer">
            <input type="checkbox" checked={!!prefs[k]} onChange={() => toggle(k)} className="mt-1" style={{accentColor: "hsl(var(--ecom-orange))"}}/>
            <div className="min-w-0 flex-1">
              <div className="font-medium text-navy">{t}</div>
              <div className="text-xs text-muted-foreground mt-0.5">{d}</div>
            </div>
          </label>
        ))}
      </div>

      <div className="card-base p-6">
        <div className="flex items-center gap-2 mb-3">
          <EnvelopeSimple size={16} className="text-orange"/>
          <div className="section-title">Test the weekly digest</div>
        </div>
        <p className="text-sm text-muted-foreground mb-4">Send a one-time digest email to yourself right now. Requires SMTP configuration in <code className="font-mono-data">backend/.env</code>.</p>
        <button data-testid="test-digest" disabled={sending} onClick={testDigest} className="btn-primary">
          {sending ? "Sending…" : "Send digest to me now"}
        </button>
      </div>

      <div className="card-base p-4 flex items-center gap-3">
        <Bell size={16} className="text-muted-foreground shrink-0"/>
        <div className="text-xs text-muted-foreground">Weekly digest is scheduled Monday 09:30 IST via <code className="font-mono-data">.emergent/crons.yml</code>. Portable to any Linux cron on Hostinger.</div>
      </div>
    </div>
  );
}
